// Browse Talent Entry
// 

JLM.MD.TalentBrowseEntry = function( division_type, container, talent_id, item_or_data ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let card, link, header_title, images, abbr_location, abbr_status, play_media,
		item_shortlist, but_shortlist, icon_shortlist, but_download, but_media;
	
	// Data
	let talent_name, talent_gender, talent_image, talent_audio, talent_video;
	
	// Settings
	let is_built = false,				// Is <li> element in DOM?
		is_onscreen = false,			// On screen?
		in_shortlist = false,			// In Shortlist?
		image_loaded = false,			// First image has loaded?
		name_search = '',				// Name search currently used
		tooltips = {};
	
	
	
	// Variables: Public ________________________________________________________
	
	// References
	INSTANCE.item = null;
	
	// Data
	INSTANCE.id = talent_id;
	
	// Settings
	INSTANCE.boundaries = { top: 0, bottom: 0 };
	INSTANCE.is_match = true;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		if ( item_or_data instanceof $ ) {
			// References
			INSTANCE.item = item_or_data;
		} else {
			// Data
			talent_name = JLM.MT.generateTalentProfileFullname( item_or_data.Firstname, item_or_data.Lastname );
			talent_gender = item_or_data.Gender;
			talent_image = '/img/' + INSTANCE.id + '/thmb/' + ( JLM.retina ? 2 : 1 ) + '/' + item_or_data.Image;
			if ( item_or_data.Audio ) talent_audio = '/assets/audio/' + INSTANCE.id + '/' + item_or_data.Audio;
			if ( item_or_data.Video ) talent_video = '/assets/video/' + INSTANCE.id + '/' + item_or_data.Video;
			
			// References
			INSTANCE.item = $('<li data-id="' + INSTANCE.id + '" />').appendTo( container );
		}
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Create from existing DOM elements
	// 
	function retrieve() {
		// References
		let actions;
		
		// Set references
		card = $('.card', INSTANCE.item);
		link = $('a', card);
			header_title = $('.header h3', link);
			images = $('.images', link);
				abbr_location = $('.location', images);
				abbr_status = $('.status', images);
		play_media = $('> button[data-type="media"]', card);
		actions = $('.action', INSTANCE.item);
			item_shortlist = $('li[data-type="shortlist"]', actions);
				but_shortlist = $('button', item_shortlist);
				icon_shortlist = $('svg use', but_shortlist);
			but_download = $('li[data-type="download"] button', actions);
			but_media = $('li[data-type="media"] button', actions);
		
		// Set data
		talent_name = header_title.text();
		talent_image = $('img', images).first().attr('src');
		
		// Settings
		INSTANCE.is_match = !( INSTANCE.item.hasClass('nomatch') );
		image_loaded = true;
	}
	
	
	// Create new DOM element from data
	// 
	function construct( data_talent ) {
		// Temp references
		let header, actions, action_list, item_download, item_media;
		
		// Create references
		card = $('<div class="card" />').appendTo( INSTANCE.item );
		link = $('<a href="' + JLM.MT.generateTalentProfileLink( division_type, talent_name ) + '" />').appendTo( card );
			header = $('<div class="header" />').appendTo( link );
				header_title = $('<h3>' + talent_name + '</h3>').appendTo( header );
			images = $('<div class="images" />').appendTo( link );
				// Voices: Avatar instead of image
				if ( division_type == JLM.NS.DIVISION_VOICES ) {
					let avatar_id = data_talent.Avatar;
					if ( !avatar_id ) {
						avatar_id = data_talent.Gender + ( 1 + Math.floor(Math.random() * 9) );
					}
					const svg_avatar = $('<svg><use xlink:href="#jl_avatar_' + avatar_id.toLowerCase() + '"></use></svg>').appendTo( images );
				}
				
				// Labels
				if ( data_talent.IsOverseas ) abbr_location = $('<abbr class="location" title="Currently Overseas"><svg><use xlink:href="#jl_icon_global"></use></svg></abbr>').appendTo( images );
				if ( data_talent.IsNew ) {
					abbr_status = $('<abbr class="status" title="New Talent!">New!</abbr>').appendTo( images );
				} else if ( data_talent.Represented ) {
					const countries = JLM.database.getCountries();
					let rep_codes = [],
						rep_names = [];
					
					// Coutnry code adjustments
					countries.GBR.Code = 'UK';
					countries.GBR.Name = 'UK';
					countries.USA.Name = 'USA';
					
					data_talent.Represented.forEach(function( rep_code ) {
						rep_codes.push( countries[ rep_code ].Code.substr(0,2) );
						if ( countries[ rep_code ] && countries[ rep_code ].Name ) {
							rep_names.push( countries[ rep_code ].Name );
						}
					});
					
					let status_names = '';
					if ( rep_names.length ) {
						status_names = 'Also represented in ';
						if ( rep_names.length == 1 ) {
							status_names += '' + rep_names[0];
						} else {
							let last_name = rep_names.pop();
							status_names += rep_names.join(', ') + ' &amp; ' + last_name;
						}
					}
					
					abbr_status = $('<abbr class="status" title="' + status_names + '">' + rep_codes.join('/') + '</abbr>').appendTo( images );
				}
		
		actions = $('<div class="action" />').appendTo( card );
			action_list = $('<ul />').appendTo( actions );
				item_shortlist = $('<li data-type="shortlist"><button type="button"><svg><use xlink:href="#jl_icon_shortlist_add"></use></svg></button></li>').appendTo( action_list );
					but_shortlist = $('button', item_shortlist);
					icon_shortlist = $('svg use', but_shortlist);
		
		// Optional links
		let num_options = 1;
		if ( data_talent.Bio && ( division_type == JLM.NS.DIVISION_ACTORS || division_type == JLM.NS.DIVISION_PRESENTERS || division_type == JLM.NS.DIVISION_MCS_ENTERTAINERS ) ) {
			item_download = $('<li data-type="download"><button type="button"><svg><use xlink:href="#jl_icon_download"></use></svg></button></li>').appendTo( action_list );
			but_download = $('button', item_download);
			num_options++;
		}
		if ( division_type == JLM.NS.DIVISION_VOICES || talent_audio || talent_video ) {
			item_media = $('<li data-type="media"><button type="button"><svg><use xlink:href="#jl_icon_media_play"></use></svg></button></li>');
			if ( division_type == JLM.NS.DIVISION_VOICES ) {
				item_media.prependTo( action_list );
			} else {
				item_media.appendTo( action_list );
			}
			but_media = $('button', item_media);
			num_options++;
		}
		action_list.attr('data-options', num_options);
	}
	
	
	// Tooltips
	//
	function onHoverSomething( type, target, message_or_tooltip ) {
		if ( !JLM.mobile ) {
			// Determine position
			let offset = target.offset(),
				pos_x = offset.left + ( target.outerWidth() / 2 ),
				pos_y = offset.top + target.outerHeight();
			
			// Tooltip content
			let message = message_or_tooltip;
			if ( message_or_tooltip == true ) {
				message = target.attr('title');
				target.attr('title', '');
			}
			
			// Create tooltip
			tooltips[ type ] = new JLM.MD.Tooltip( pos_x, pos_y, message );
			target.one('mouseleave', function() {
				if ( tooltips[ type ] ) {
					tooltips[ type ].remove();
					tooltips[ type ] = null;
					target.attr('title', message);
				}
			});
		}
	}
	function onHoverLocation() {
		onHoverSomething( 'location', abbr_location, true );
	}
	function onHoverStatus() {
		onHoverSomething( 'location', abbr_status, true );
	}
	function onHoverShortlist() {
		let message = ( in_shortlist ? 'Remove from Shortlist…' : 'Add to Shortlist…' );
		onHoverSomething( 'shortlist', but_shortlist, message );
	}
	function onHoverDownload() {
		onHoverSomething( 'download', but_download, 'Download Biography' );
	}
	function onHoverMedia() {
		let message = 'Play Showreel';
			if ( division_type == JLM.NS.DIVISION_VOICES ) message = 'Play Sample Track';
		onHoverSomething( 'media', but_media, message );
	}
	
	
	// Event: Click
	// 
	function onClick( event ) {
		// event.preventDefault();
	}
	
	
	// Actions: Shortlist
	// 
	function onToggleShortlist() {
		if ( in_shortlist ) {
			removeFromShortlist();
			INSTANCE.dispatchEvent('shortlist_remove');
		} else {
			addToShortlist();
			INSTANCE.dispatchEvent('shortlist_add');
		}
	}
	function addToShortlist() {
		if ( is_built ) {
			// Update button
			icon_shortlist.attr('xlink:href', '#jl_icon_shortlist_remove');
			item_shortlist.addClass('selected');
			
			// Update tooltip
			if ( tooltips['shortlist'] ) {
				tooltips['shortlist'].update('Added!');
				setTimeout(function() {
					if ( tooltips['shortlist'] ) tooltips['shortlist'].remove();
					tooltips['shortlist'] = null;
				}, 1000);
			}
		}
		
		// Update settings
		in_shortlist = true;
	}
	function removeFromShortlist() {
		if ( is_built ) {
			// Update button
			icon_shortlist.attr('xlink:href', '#jl_icon_shortlist_add');
			item_shortlist.removeClass('selected');
			
			// Update tooltip
			if ( tooltips['shortlist'] ) {
				tooltips['shortlist'].update('Removed!');
				setTimeout(function() {
					if ( tooltips['shortlist'] ) tooltips['shortlist'].remove();
					tooltips['shortlist'] = null;
				}, 1000);
			}
		}
		
		// Update settings
		in_shortlist = false;
	}
	
	
	// Action: Download Bio
	// 
	function downloadBio() {
		// Update tooltip
		if ( tooltips['download'] ) {
			tooltips['download'].update('Downloading…');
			setTimeout(function() {
				if ( tooltips['download'] ) tooltips['download'].remove();
				tooltips['download'] = null;
			}, 1000);
		}
		
		// Track
		JLM.MT.trackEvent('Download', {
			event_category: 'Biography',
			event_label: JSON.stringify({
				talent: talent_id,
				division: division_type
			})
		});
		
		// Download
		let talent_name_url = JLM.MT.generateTalentNameURL( talent_name );
		window.location.href = JLM.MT.generateBioURL( INSTANCE.id, talent_name_url, division_type );
	}
	
	
	// Action: Play Media
	// 
	function playMedia() {
		let talent_name_url = JLM.MT.generateTalentNameURL( talent_name );
		if ( division_type == JLM.NS.DIVISION_VOICES ) {
			JLM.MD.MediaPlayer.launchAudioPlayer( talent_id, talent_name_url );
		} else {
			JLM.MD.MediaPlayer.launchVideoPlayer( talent_id, talent_name_url, division_type );
		}
	}
	function playMediaPreview() {
		let talent_name_url = JLM.MT.generateTalentNameURL( talent_name );
		if ( division_type == JLM.NS.DIVISION_VOICES ) {
			JLM.MD.MediaPlayer.launchAudioPlayer( talent_id, talent_name_url );
		} else {
			JLM.MD.MediaPlayer.launchVideoPlayer( talent_id, talent_name_url, division_type );
		}
	}
	
	
	// Load talent image
	// 
	function loadImage( image_src ) {
		// Create loading icon
		let icon = new JLM.MD.IconLoading( images );
		
		// Start load
		const image = new Image();
		image.onload = function() {
			let image_instance = $('<img src="' + image_src + '">').appendTo( images );
			setTimeout(function() {
				if ( icon ) icon.remove();
				image_instance.addClass('reveal');
			}, 10);
		};
		image.onerror = function() {
			let img_missing = '/images/talent/missing_' + ( talent_gender == 'M' ? 'male' : 'female' ) + '.jpg';
			if ( img_missing !== image_src ) {
				loadImage( img_missing );
			}
			icon.remove();
		};
		image.src = image_src;
	}
	
	
	// Name highlight
	// 
	function highlightName( search_term ) {
		let regex = new RegExp("\\b(" + search_term + ')', "i"),
			talent_name_highlighted = talent_name.replace(regex, '<em>$1</em>');
		if ( is_built ) header_title.html( talent_name_highlighted );
		name_search = search_term;
	}
	function clearHighlight() {
		if ( is_built ) header_title.html( talent_name );
		name_search = '';
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Update dimensions
	// 
	INSTANCE.setBoundaries = function( top, bottom ) {
		INSTANCE.boundaries.top = top;
		INSTANCE.boundaries.bottom = bottom;
	};
	
	
	// Load into DOM
	// 
	INSTANCE.load = function() {
		// Retrieve or build
		if ( item_or_data instanceof $ ) retrieve( item_or_data );
		else construct( item_or_data );
		
		// Settings
		is_built = true;
		in_shortlist = JLM.database.isInShortlist( INSTANCE.id, division_type );
		
		// Events
		link.on('click', onClick);
		if ( abbr_location ) abbr_location.on('mouseover', onHoverLocation);
		if ( abbr_status ) abbr_status.on('mouseover', onHoverStatus);
		if ( play_media ) play_media.on('click', playMediaPreview);
		but_shortlist.on('mouseover', onHoverShortlist).on('click', onToggleShortlist);
		if ( but_download ) but_download.on('mouseover', onHoverDownload).on('click', downloadBio);
		if ( but_media ) but_media.on('mouseover', onHoverMedia).on('click', playMedia);
		
		// Setup
		if ( !INSTANCE.is_match ) INSTANCE.item.addClass('nomatch');
		if ( in_shortlist ) addToShortlist();
		if ( name_search ) highlightName( name_search );
	};
	
	
	// Update status for if item is on screen
	// 
	INSTANCE.setOnScreen = function( now_onscreen ) {
		if ( now_onscreen && !is_onscreen ) {
			if ( !is_built ) INSTANCE.load();
			INSTANCE.item.removeClass('offscreen');
			if ( !image_loaded ) {
				loadImage( talent_image );
				image_loaded = true;
			}
		}
		else if ( !now_onscreen && is_onscreen ) {
			INSTANCE.item.addClass('offscreen');
		}
		
		is_onscreen = now_onscreen;
	};
	
	
	// Update status for if item is search match
	// 
	INSTANCE.setIsMatch = function( now_ismatch, search_term ) {
		// Show / Hide
		if ( now_ismatch && !INSTANCE.is_match ) {
			INSTANCE.item.removeClass('nomatch');
			
			// Animate reveal
			if ( is_onscreen && card ) {
				card.addClass('reveal_prep');
				setTimeout(function() {
					card.addClass('reveal_show');
					setTimeout(function() {
						card.removeClass('reveal_prep reveal_show');
					}, 500);
				}, 10);
			}
		} else if ( !now_ismatch && INSTANCE.is_match ) {
			INSTANCE.item.addClass('nomatch');
		}
		INSTANCE.is_match = now_ismatch;
		
		// Highlight / Clear name
		if ( now_ismatch ) {
			if ( search_term ) {
				highlightName( search_term );
			} else {
				clearHighlight();
			}
		} else if ( !now_ismatch && name_search ) {
			clearHighlight();
		}
	};
	
	
	// Remove from Shortlist
	// 
	INSTANCE.removeFromShortlist = function() {
		if ( in_shortlist ) removeFromShortlist();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};